import _ from 'lodash'

export function cleanPrinters (settingsBlob) {
  _.get(settingsBlob, 'printing.printers', []).forEach(printer => cleanPrinter(printer, settingsBlob))
}

export function cleanPrinter (printer, settingsBlob) {
  const stations = _.get(settingsBlob, 'stations', []).map(it => it.id)

  if (printer.stationId && !stations.includes(printer.stationId)) {
    printer.stationId = null
  }

  const printers = _.get(settingsBlob, 'printing.printers', []).map(it => it.id)
  if (printer.backupPrinterId && !printers.includes(printer.backupPrinterId)) {
    printer.backupPrinterId = null
  }
}
